<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  name: 'BarChart',
  mounted () {
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          label: this.barlabel,
          backgroundColor: this.barcolor,
          data: this.chartdata,
        }
      ]
    },
    {
      responsive: true,
    })
  },  
  props: {
    barlabel: {
      type: String,
      default: '',
      required: false,
    },
    labels: {
      type: Array,
      required: true,
    },
    chartdata: {
      default: () => { [0] },
      type: Array,
      required: true,
    },
    barcolor: {
      type: String,
      default: '#8bcac1',
      required: false,
    }
  },
  data: function() {
    return {
    }
  },
}
</script>
<style scoped>

</style>